import * as angular from "angular";
import {IController} from "angular";

export class taskPurposeCtrl implements IController {

  purpose: any;
  isBundle: boolean;
  textClass: any;
  firstLetterOnly: boolean;

  private text: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (this.purpose) {
      this._setText();
    }
  };

  $onChanges(changes) {
    if (changes.purpose && !changes.purpose.isFirstChange()) {
      if (this.purpose) {
        this._setText();
      }
    }
  };

  _setText() {
    let text = '';
    text += (this.firstLetterOnly ? this.purpose.charAt(0) : this.purpose);

    this.text = text;
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskPurpose', {
    bindings: {
      purpose: '<',
      isBundle: '<?',
      textClass: '@?',
      firstLetterOnly: '@?'
    },
    template: require('./task-purpose.html').default,
    controller: taskPurposeCtrl
  });
